import { ContentSpacer, Content } from './styled';
export function SectionContent(props) {
    const { children } = props;
    return (<Content>
      <ContentSpacer>{children}</ContentSpacer>
    </Content>);
}
